import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { nest } from 'recompose';

export const wrapHoc = (OuterComponent) => (WrappedComponent) => {

  return class extends Component {

    static propTypes = {
      editable: PropTypes.bool,
    };

    static defaultProps = {
      editable: true,
    };

    render() {
      const { editable } = this.props;

      if (!editable) return <WrappedComponent { ...this.props } />;

      const ComposedComponent = nest(OuterComponent, WrappedComponent);

      return <ComposedComponent { ...this.props } />;
    }
  };
};

